import { Activity, Children, use, type ReactNode } from 'react';

import { cn } from '@/lib/cn';

import { FlowContext, isStepElement } from '.';

type StepListProps = {
  children: ReactNode;
};

export const StepList = ({ children }: StepListProps) => {
  const { currentStep } = use(FlowContext);
  const stepElements = Children.toArray(children).filter(isStepElement);

  const stepNames = stepElements.map(step => step.props.name);
  const uniqueStepNames = Array.from(new Set(stepElements.map(step => step.props.name)));

  const currentStepName = currentStep?.name ?? stepNames[0];

  if (uniqueStepNames.length !== stepElements.length) {
    console.warn('Step names must be unique', stepNames);
  }

  return (
    <>
      {stepElements.map(step => {
        const isCurrentStep = currentStepName === step.props.name;

        return (
          <Activity key={step.props.name} mode={isCurrentStep ? 'visible' : 'hidden'}>
            <div className={cn('flex flex-1 flex-col', { 'animate-step-in': isCurrentStep })}>{step}</div>
          </Activity>
        );
      })}
    </>
  );
};
